// Maps category IDs to primary measurement dimensions for variant selector display.
// See README.md for detailed documentation on setup and measurement mapping.
export const categoryMeasurementMap = [
  { id: 2640, name: "trousers-leggings", measurement: "Waist" },
  { id: 3630, name: "jeans", measurement: "Waist" },
  { id: 15157, name: "slim-jeans", measurement: "Waist" },
  { id: 2639, name: "skirts", measurement: "Waist" },
  { id: 8799, name: "dresses", measurement: "Bust" },
  { id: 4169, name: "tops", measurement: "Bust" },
  { id: 2641, name: "coats-jackets", measurement: "Bust" },
  { id: 4910, name: "trousers-chinos", measurement: "Waist" },
  { id: 4208, name: "jeans", measurement: "Waist" },
  { id: 3602, name: "shirts", measurement: "Chest" },
  { id: 7616, name: "t-shirts-vests", measurement: "Chest" },
  { id: 7617, name: "jumpers-cardigans", measurement: "Chest" },
  { id: 3606, name: "jackets-coats", measurement: "Chest" },
  { id: 7078, name: "shorts", measurement: "Waist" },
];
